import axios from 'axios';
import consts from '../consts';
import { setErroAPI, setSuccess } from '../common/toast/toast';

const API = `${consts.API_URL}/cidade/listarSelect`;

export const CIDADE_LISTADO = 'CIDATE_LISTADO';

export function getLista() {
    return async dispatch => {
        try {

            const resp = await axios.get(API);

            dispatch({
                type: CIDADE_LISTADO,
                payload: resp
            });

        } catch (erro) {
            setErroAPI(erro);
        }
    };
}